import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { StaticFileService } from '../../static-file.service';

@Component({
  selector: 'app-confirmation-page',
  templateUrl: './confirmation-page.component.html',
  styleUrls: ['../cart-page.component.css', './confirmation-page.component.css']
})
export class ConfirmationPageComponent implements OnInit, AfterViewInit {

  constructor(private staticFileService: StaticFileService, private el: ElementRef) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.scrollToMe();
  }

  private scrollToMe() {
    this.el.nativeElement.scrollIntoView({behavior:'smooth'});
  }

}
